<template>
  <v-layout fill-height>
    <v-flex xs12 sm4>
      <div class="ma-4">
        <v-text-field
          pa-1
          label="Rechercher..."
          append-outer-icon="search"
          v-model="searchValue"
          >Recherche...</v-text-field
        >
      </div>
      <v-card>
        <v-list two-line class="pa-0">
          <template v-for="(student, index) in filteredStudents">
            <v-list-tile
              :key="student._id"
              avatar
              ripple
              @click="selected = student"
            >
              <v-list-tile-content>
                <v-list-tile-title
                  >{{ student.firstName }}
                  {{ student.lastName }}</v-list-tile-title
                >
                <v-list-tile-sub-title class="text--primary">{{
                  student.messages[0].subject
                }}</v-list-tile-sub-title>
                <v-list-tile-sub-title>{{
                  student.messages[0].body
                    ? "Bonjour, Vous trouverez, en fichier joint, votre bulletin de notes. Avec mes meilleures salutations,"
                    : "En attente"
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-list-tile-action-text>{{
                  student.messages[0].dateSent | formatDate
                }}</v-list-tile-action-text>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider
              v-if="index + 1 < students.length"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
      </v-card>
    </v-flex>
    <v-flex xs12 sm8 ma-3 v-if="selected">
      <v-card
        v-for="message in selected.messages"
        :key="message._id"
        class="mt-3"
      >
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs6 class="font-weight-medium subheading">{{
              message.sender
            }}</v-flex>
            <v-flex xs6 class="text-xs-right grey--text"
              >{{ message.dateSent | formatDetailDate }} à
              {{ message.dateSent | formatDetailTime }}</v-flex
            >
            <v-flex xs12>{{ message.subject }}</v-flex>
            <v-flex xs12
              >À :
              <span class="grey--text"
                >{{ selected.firstName }} {{ selected.lastName }}</span
              >
            </v-flex>
            <v-flex xs12>
              <v-divider class="mt-3 mb-3" />
            </v-flex>
            <v-flex xs12>
              <span v-if="message.delivered" v-html="message.body"></span>

              <div class="attachment" @click="downloadReport(message._id)">
                <v-icon x-large>fa-file-pdf</v-icon>
                <div>{{ selected.idisa }}.pdf</div>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  sockets: {
    messages: function (data) {
      this.students = data.messages;
      this.selected = data.messages.find((m) => m._id === this.selected._id);
    },
  },
  props: ["keycloak"],
  data() {
    return {
      user: undefined,
      students: [],
      selected: {},
      searchValue: "",
    };
  },
  filters: {
    formatDate: function (date) {
      return moment(date).format("DD.MM.YY");
    },
    formatDetailDate: function (date) {
      return moment(date).format("DD MMMM YYYY");
    },
    formatDetailTime: function (date) {
      return moment(date).format("HH:mm");
    },
  },
  async mounted() {
    if (this.keycloak && this.keycloak.token) {
      this.keycloak.loadUserInfo().then((user) => {
        this.user = user;
      });
      this.$socket.io.opts.query = `token=${this.keycloak.token}`;
      this.$socket.connect();
      this.loading = true;
      try {
        const { data } = await axios(
          `${process.env.VUE_APP_API_URL}/messages`,
          {
            method: "GET",
          }
        );
        this.students = data;
        this.loading = false;
      } catch (e) {
        if (e.response.status === 403) {
          this.keycloak.logout();
        }
      }
    }
  },
  methods: {
    downloadReport: async function (reportId) {
      const { data } = await axios({
        url: `${process.env.VUE_APP_API_URL}/reports/${reportId}`,
        method: "GET",
        responseType: "blob",
      });
      const file = new Blob([data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      window.open(url);
    },
  },
  computed: {
    filteredStudents: function () {
      const filtered = this.students.filter((student) => {
        const regex = new RegExp(this.searchValue.toLowerCase(), "g");
        return (
          `${student.firstName.toLowerCase()} ${student.lastName.toLowerCase()}`.match(
            regex
          ) ||
          `${student.lastName.toLowerCase()} ${student.firstName.toLowerCase()}`.match(
            regex
          )
        );
      });
      return filtered.sort(
        (a, b) =>
          new Date(b.messages[0].dateSent) - new Date(a.messages[0].dateSent)
      );
    },
  },
};
</script>

<style scoped>
.sticky {
  height: 400px;
  position: sticky;
  top: 0;
}
.v-progress-circular {
  margin: 1rem;
}
.progress-div {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.attachment {
  width: fit-content;
  text-align: center;
  cursor: pointer;
}
</style>
